<template>
  <div class="iw-btn-play-tooltip d-flex justify-content-center align-items-center"><span>{{ __('Hai ') }} <strong v-text="attempts_left + __( attempts_left > 1 ? ' giocate' : ' giocata')"></strong> {{ __(' per tentare la fortuna.') }}</span></div>
</template>

<script>
import TimPartyMixin from "@/mixins/TimPartyMixin";

export default {
  name: "InstantWinBasicAttempts",
  mixins: [TimPartyMixin],
  props: {
    attempts_left: Number
  },
  watch: {
    attempts_left: function () {}
  }
}
</script>
